<template>
    <div>
        <el-form :inline="true">
            <el-form-item label=" 代币币种">
                <coin-select :coinType = "queryCondition.coinType" @value="val => queryCondition.coinType = val"></coin-select>
            </el-form-item>
            <el-form-item label="法币">
                <coin-select :coinType = "queryCondition.currencyCoin" @value="val => queryCondition.currencyCoin = val"></coin-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryFeeInfo()">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="opType = 'insert',showEdit = true">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="feeInfo">
            <el-table-column label="代币币种" prop="coinType"></el-table-column>
            <el-table-column label="法币币种" prop="currencyCoin"></el-table-column>
            <el-table-column label="买方手续费" prop="buyerFeeRate"></el-table-column>
            <el-table-column label="卖方手续费" prop="sellerFeeRate"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="alterEdit(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination background layout="prev, pager, next" :total="feeTotal" :page-size="15" :current-page="queryCondition.pageNo"
                       @current-change="pageChange"></el-pagination>

        <el-dialog title="OTC手续费配置" :visible.sync= "showEdit" @close="closeDialog">
            <el-form label-width="180px" :model="feeEditInfo" ref="feeEditForm">
                <el-form-item label=" 代币币种">
                    <coin-select :coinType = "feeEditInfo.coinType" @value="val => feeEditInfo.coinType = val"></coin-select>
                </el-form-item>
                <el-form-item label="法币">
                    <coin-select :coinType = "feeEditInfo.currencyCoin" @value="val => feeEditInfo.currencyCoin = val"></coin-select>
                </el-form-item>
                <el-form-item label="买方手续费" prop="buyerFeeRate" :rules="[{ required: true, message: '买方手续费不能为空',trigger: 'blur'}]">
                    <el-input-number v-model="feeEditInfo.buyerFeeRate"></el-input-number><span>{{feeEditInfo.coinType}}</span>
                </el-form-item>
                <el-form-item label="卖方手续费" prop="sellerFeeRate" :rules="[{ required: true, message: '卖方手续费不能为空',trigger: 'blur'}]">
                    <el-input-number v-model="feeEditInfo.sellerFeeRate"></el-input-number><span>{{feeEditInfo.coinType}}</span>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="closeDialog()">取消</el-button>
                    <el-button type="primary" @click="saveFeeInfo()">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
    import api from './api';
    import './store';
    import {mapActions, mapState} from 'vuex';
    import coinSelect from '../../../components/coinSelect';
    export default {
        name: "fee",
        components:{coinSelect},
        data(){
            return {
                showEdit:false,
                opType: '',
                feeEditInfo:{},
                queryCondition:{pageNo:1}
            }
        },
        computed : {...mapState('otcConfig',['feeTotal','feeInfo'])},
        methods:{
            ...mapActions('otcConfig',['findFeeInfo']),
            saveFeeInfo(){
                this.$refs['feeEditForm'].validate(valid =>{
                   if (valid){
                       if (!this.feeEditInfo.coinType){this.$message.error('代币币种不能为空');return;}
                       if (!this.feeEditInfo.currencyCoin){this.$message.error('法币币种不能为空');return;}
                       if (this.opType === 'insert'){
                           api.feeInsert(this.feeEditInfo).then(()=>{
                               this.$message.success('新增成功');
                               this.queryCondition.pageNo = 1;
                               this.queryFeeInfo();
                               this.closeDialog();
                           })
                       }
                       if (this.opType === 'update'){
                           api.feeUpdate(this.feeEditInfo).then(()=>{
                               this.$message.success('修改成功');
                               this.queryCondition.pageNo = 1;
                               this.queryFeeInfo();
                               this.closeDialog();
                           })
                       }
                   }
                })
            },
            closeDialog(){
                this.showEdit = false;
                this.$refs['feeEditForm'].resetFields();
                this.feeEditInfo = {};
            },
            queryFeeInfo(){
                this.findFeeInfo(this.queryCondition);
            },
            pageChange(val){
                this.queryCondition.pageNo = val;
                this.queryFeeInfo();
            },
            alterEdit(row){
                this.feeEditInfo = JSON.parse(JSON.stringify(row));
                this.opType = 'update';
                this.showEdit = true;
            }
        },
        created() {
            this.queryFeeInfo();
        }
    }
</script>

<style scoped>

</style>